export enum Keys {
    ArrowUp = 'ArrowUp',
    ArrowDown = 'ArrowDown',
    ArrowLeft = 'ArrowLeft',
    ArrowRight = 'ArrowRight',
    Escape = 'Escape',
    Backspace = 'Backspace',
    Delete = 'Delete',
    Enter = 'Enter',
    Tab = 'Tab',
    Shift = 'Shift',
    Control = 'Control',
    Alt = 'Alt',
    Meta = 'Meta',
    KeyC = 'KeyC',
    KeyV = 'KeyV',
    KeyX = 'KeyX',
    KeyA = 'KeyA',
    KeyS = 'KeyS',
    KeyZ = 'KeyZ',
    KeyY = 'KeyY',
    KeyG = 'KeyG',
}
